<div class="container-fluid">
    <div class="row mt-3">
        <div class="col-2">
            <div class="card">
                <div class="card-body">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">Devices</a>
                        <a class="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">Device Manufactures</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-10">
            <div class="card">
                <div class="card-body">
                    <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                            <a href="/hardware/devices/insert" class="btn btn-primary btn-sm float-right">Add Device</a>
                            <div class="clearfix"></div>
                            <hr />
                            <app-data-table [columns]="columns" [loadPage]="loadPage" [(filters)]="filters" [filtersComponent]="dataFilters">
                                <app-data-filters #dataFilters>
                                    <app-data-filter-group>
                                        <app-data-filter-input label="Device Name" [(model)]="filters.name" placeholder="Device Name">
                                        </app-data-filter-input>
                                        <app-data-filter-select label="Device Status" placeholder="Device Status" [(model)]="filters.status" [options]="deviceStatusArray">
                                        </app-data-filter-select>
                                        <app-data-filter-datepicker label="Start Date" [(model)]="filters.startdate">
                                        </app-data-filter-datepicker>
                                        <app-data-filter-datepicker label="End Date" [(model)]="filters.enddate">
                                        </app-data-filter-datepicker>
                                    </app-data-filter-group>
                                </app-data-filters>
                            </app-data-table>
                        </div>
                        <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                            <div style=" padding: 1px 2px 3px 4px;">
                                <a href="/hardware/manufacturer/insert" class="btn btn-primary btn-sm float-right">Add
                                    New Device Manufacturer</a>
                            </div>
                            <div class="table-responsive data-table-column">
                                <table class="table table-sm text-left">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Device Manufacturer Name</th>
                                            <th class="text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let deviceManufacturer of deviceManufacturersVals">
                                            <td>{{deviceManufacturer.id}}</td>
                                            <td>{{deviceManufacturer.name}}</td>
                                            <td class="text-right">
                                                <div class="btn-group">
                                                    <a href="hardware/manufacturer/update/{{deviceManufacturer.id}}" class="btn btn-secondary btn-sm"><i
                                                            class="fa fa-pencil-alt"></i>
                                                        Edit
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #id let-id="id">
        <input type="checkbox" [value]="id" />
    </ng-template>

    <ng-template #name let-name="name">
        {{name}}
    </ng-template>

    <ng-template #deviceManufacturer let-deviceManufacturer="deviceManufacturer">
        {{deviceManufacturer.name}}
    </ng-template>

    <ng-template #deviceType let-deviceType="deviceType">
        {{deviceType.name}}
    </ng-template>

    <ng-template #status let-status="status">
        {{status | deviceStatus}}
    </ng-template>

    <ng-template #notes let-notes="notes">
      <ng-container *ngIf="notes; else noNotes">
          <div class="notes-container">
            <i style="color: #1DC7EA;" class="notes-icon fas fa-2x fa-info-circle"></i>
            <div class="notes-content">
              <div class="title">Notes</div>
              <div class="content" [innerHTML]="notes | replaceLineBreaks"></div>
            </div>
          </div>
      </ng-container>
      <ng-template #noNotes>
      </ng-template>
    </ng-template>

    <ng-template #deviceAssignedCount let-deviceAssignedCount="deviceAssignedCount">
      {{deviceAssignedCount}}
    </ng-template>

    <ng-template #assignedEvent let-assignedEvent="assignedEvent">
      <div style="width:200px; height:50px; overflow-y: scroll; background-color: #fafafa; padding:3px 6px;" [innerHtml]="showAssignedEvent(assignedEvent)" *ngIf="assignedEvent"></div>
    </ng-template>

    <ng-template #actionsColumn let-id="id">
        <div class="btn-group navbar p-0" style="display: block">
            <a href="hardware/devices/update/{{id}}" class="btn btn-secondary btn-sm"><i class="fa fa-pencil-alt"></i>
                Edit</a>
            <button type="button" class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width: 30px">
                <span class="sr-only">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
                <a href="hardware/devices/view/{{id}}" class="dropdown-item btn btn-sm"><i
                        class="fa fa-search-plus"></i> View</a>
                <button type="button" class="dropdown-item btn-sm" (click)="softDeleteDevice(id, '0')"><i
                        class="fa fa-trash-alt"></i>Delete</button>
            </div>
        </div>
    </ng-template>
</div>
